import * as types from './types'

const intitialState = {
    list: [],
}

const identifyReducer = (state = intitialState, action) => {
    switch (action.type) {
        case types.IDENTIFY_USER: {
            return {
                ...state,
                ...action.payload
              }
        }             
        case types.IDENTIFY_USER_ERR: {
            return intitialState
        }
        case types.RESET_IDENTIFY_USER: {
            return intitialState
        }    
        default:
            return state;
    }

}

export default identifyReducer